import { Link } from "react-router-dom";
import { File } from "../files.types";
import { useCaseFiles } from "../Hooks";
import { styled } from "@monolith-forensics/monolith-ui";

const StyledLink = styled(Link)`
  text-decoration: none;
  &:hover {
    color: ${({ theme }) => theme.palette.primary.main};
    text-decoration: underline;
  }
`;

export const FilePathComponent: React.FC<{ data: File }> = ({ data }) => {
  const { tableRef } = useCaseFiles();

  // Asset attachments have no case to link into.
  if (!data.case) return <>{data.path}</>;

  const isFolder = data.is_folder;
  return (
    <StyledLink
      to={`/cases/${data.case?.case_id}/documents/folders/${
        isFolder ? data?.uuid : data?.parent?.uuid
      }`}
      onClick={() => {
        tableRef?.current?.clearSearch();
      }}
    >
      {data.path}
    </StyledLink>
  );
};
